"use client";

import { useEffect } from "react";
import { agentStore } from "@/features/agent";

/**
 * Tells a running agent session that the page the visitor landed on does not
 * exist. Mounted on the 404 page (`[locale]/not-found.tsx`), which renders
 * inside the locale layout — so the agent widget, and its session, are still
 * alive here after a client-side `router.push` to a dead URL.
 *
 * The note itself never appears in the chat, but the agent answers it right away.
 * A no-op when no session is running.
 */
export const AgentNotFoundReporter: React.FC = () => {
  useEffect(() => {
    agentStore.reportPageNotFound(window.location.pathname);
  }, []);

  return null;
};
